// extracted by mini-css-extract-plugin
export default {"infoWrapper":"customerInfo_infoWrapper__qwQd5","flexCenter":"customerInfo_flexCenter__zOP67"};